import {
  AccountDto,
  UpdateAccountRequest
} from '../types/AccountDefault.types';
import API from './ApiBase';

export async function getMyAccount() {
  return await API.get<AccountDto>(`/accounts/me`);
}

// Only the display name is updatable: the slug is the Keycloak group path and is
// baked into every issued token, so the API rejects it.
export async function updateAccount(
  accountId: string,
  bodyRequest: UpdateAccountRequest
) {
  return await API.patch<AccountDto>(`/accounts/${accountId}`, bodyRequest);
}
